import { graphql, useStaticQuery } from "gatsby"
import { TTeamMember } from "../types"

const allTeamMembers = (): TTeamMember[] => {
  const query = useStaticQuery(
    graphql`
      query {
        allTeamMember {
          nodes {
            id
            name
            lastName
            pronouns
            categories {
              slug
            }
            avatar {
              id
              title
              ... on DatoCmsAsset {
                gatsbyImageData(
                  imgixParams: {crop: "focalpoint", fit: "crop", w: "200", h: "200"}
                )
              }
            }
            company
            thirdStoneTitle
            occupationTitle
            description {
              id
              blocktype
              ...FormattedTextContent
              ...ImageContent
              ...VideoContent
            }
          }
        }
      }
    `
  )
  return query.allTeamMember.nodes
}

export default allTeamMembers
